// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"fc70e174","412":"35ff97fc","503":"41334c2d"}[chunkId] + ".chunk.js";
};